/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey, searchScope }) {
    const queryParams = new URLSearchParams();
    if (searchKey) queryParams.append('search', searchKey);
    if (searchScope) queryParams.append('search_scope', searchScope);

    const queryString = queryParams.toString();
    const url = queryString ? `${this.url}?${queryString}` : this.url;
    return axios.get(url);
  }
}

export default new CannedResponse();
